<template>
    <div class="box">
        <div class="box-header box-clearfix">
            <div class="box-title">
                <a href="javascript:;">Deposit</a>
            </div>
        </div>
        <div class="box-body">
            <div class="deposit">
                <ul class="deposit-nav">
                    <li>Bank Transfer</li>
                </ul>
                <bankTransfer></bankTransfer>
            </div>
        </div>
    </div>
</template>

<script>
  import bankTransfer from './bankTransfer'

  export default {
    data () {
      return {}
    },
    methods: {},
    components: {bankTransfer}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .deposit {
        .deposit-nav {
            margin-top: 23px;
            li {
                position: relative;
                display: inline-block;
                font-size: 20px;
                line-height: 24px;
                color: #0A95FF;
                border-bottom: 2px solid #0A95FF;
                &:before {
                    position: absolute;
                    left: 50%;
                    bottom: -6px;
                    margin-left: -4px;
                    content: '';
                    width: 0;
                    height: 0;
                    border-width: 4px 4px 0 4px;
                    border-color: #0A95FF transparent transparent transparent;
                    border-style: solid;
                }
            }
        }
    }
</style>
